/**
 * 
 * @param {String} search 
 * @returns {{}}
 */
export const parseCustomQueryString = (search) => {
    if (!search) return {}
    const parts = (search.substring(1)).split("?");
    const params = {};
    let unnamedIndex = 0; // Contador para valores sin clave
    parts.forEach((part) => {
        const [key, value] = part.split("=");
        if (!value)
            params[unnamedIndex++] = key;
        else
            params[key] = value;
    });

    return params;
};